import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import Logo from '@/components/Logo';
import { LANGS, LANG_CODES } from '@/i18n/routes';

const TEXTS = {
  'pt-br': { title: 'Escolha a sua versão', sub: 'Cada versão é completa, com conteúdo próprio para o seu mercado: Brasil ou toda a Latinoamérica.' },
  es: { title: 'Elige tu versión', sub: 'Cada versión es completa, con contenido propio para tu mercado: Brasil o toda la Latinoamérica.' },
};

export default function LangGate() {
  const [saved] = useState(() => localStorage.getItem('rt_lang'));
  const [suggested, setSuggested] = useState('pt-br');

  useEffect(() => {
    const nav = (navigator.language || '').toLowerCase();
    setSuggested(nav.startsWith('es') ? 'es' : 'pt-br');
  }, []);

  if (saved && LANG_CODES.includes(saved)) return <Navigate to={`/${saved}`} replace />;
  const t = TEXTS[suggested] || TEXTS['pt-br'];

  const go = (code) => {
    localStorage.setItem('rt_lang', code);
    window.location.href = `/${code}`;
  };

  return (
    <div data-testid="lang-gate" className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-brand-mist px-6 py-14">
      <div className="grid-dots absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-brand-blue/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-brand-cyan/20 blur-3xl" />
      <div className="relative w-full max-w-2xl text-center">
        <Logo className="mx-auto !h-24 md:!h-32 translate-x-[4%]" />
        <span className="mt-10 block font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-blue">Rodotrack · Tecnologia Satelital</span>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-5xl">{t.title}</h1>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-brand-muted">{t.sub}</p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-gate-option-${l.code}`}
              onClick={() => go(l.code)}
              className={`group rounded-2xl border bg-white p-6 text-left transition-all duration-300 hover:-translate-y-1 hover:border-brand-blue hover:shadow-[0_24px_48px_-24px_rgba(30,159,224,0.4)] ${suggested === l.code ? 'border-brand-blue ring-2 ring-brand-blue/20' : 'border-brand-line'}`}
            >
              <span className="flex items-center justify-between">
                <span className="font-display text-lg font-bold text-brand-navy">{l.label}</span>
                {suggested === l.code ? (
                  <span className="inline-flex items-center gap-1 rounded-full bg-brand-ice px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-brand-blue">
                    <Check className="h-3 w-3" /> {suggested === 'pt-br' ? 'Sugerido' : 'Sugerido'}
                  </span>
                ) : (
                  <ArrowRight className="h-4 w-4 text-brand-blue opacity-0 transition group-hover:opacity-100" />
                )}
              </span>
              <span className="mt-2 block text-[13px] text-brand-muted">{l.sub}</span>
            </button>
          ))}
        </div>
        <p className="mt-10 text-[12px] text-brand-muted">Rastreamento veicular · Gestão de frotas · Brasil · Paraguai · Argentina</p>
      </div>
    </div>
  );
}